import { render, staticRenderFns } from "./whitelists.vue?vue&type=template&id=519dbc8d"
import script from "./whitelists.vue?vue&type=script&lang=ts"
export * from "./whitelists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports